<template>
    <div class="fx-g1" v-loading="loading" element-loading-text="数据拼命加载中...">
        <div class="item_block fx fx-c_center info_row">
            <div class="coverimg">
                <el-image
                    style="width: 150px; height: 90px"
                    :src="lessonSystem.coverImg"
                    :lazy="true"
                    :preview-src-list="[lessonSystem.coverImg]"
                    fit="fill"></el-image>
            </div>

            <div style="width: 180px">{{lessonSystem.name}}</div>

            <div> <el-tag size="mini" effect="dark">{{lessonSystem.typeName}}</el-tag> </div>

            <div style="width: 120px" class="fx-col fx-center">
                <span>课程数量：{{lessonSystem.lessonCount}}</span>
                <span>适合人群：{{lessonSystem.suitCrowd}}</span>
            </div>
            <div class="fx-g1">
                <p>{{lessonSystem.introduction}}</p>
            </div>
            <div style="width: 160px">
                <tag-group :tags="lessonSystem.tagArray" size="mini" ></tag-group>
            </div>
        </div>

        <div v-for="lesson in lessons" :key="lesson.id" class="item_block">
            <div class="fx fx-c_center info_row" style="border-bottom: 1px solid var(--border)">
                <div class="coverimg">
                    <el-image
                        style="width: 150px; height: 90px"
                        :src="lesson.coverImg"
                        :lazy="true"
                        :preview-src-list="[lesson.coverImg]"
                        fit="fill"></el-image>
                </div>

                <div style="width: 380px;" >
                    <div class="lesson_name">{{lesson.name}}</div>
                    <div class="fx fx-m_between fx-c_center lesson_resource" style="margin-top: 12px">
                        <span class="fx fx-c_center">视频:
                            <span v-if="lesson.videos.length==0" class="text_info tip"> 未设置</span>
                            <el-link v-else type="primary" @click="setShowResources(lesson.videos)" :underline="false" class="font12"><i class="iconfont icon-shipin"></i>查看</el-link>
                        </span>
                        <span class="fx fx-c_center">教案:
                            <span v-if="lesson.plans.length==0" class="text_info tip"> 未设置</span>
                                    <el-link v-else type="primary" @click="setShowResources(lesson.plans)" :underline="false" class="font12"><i class="iconfont icon-word"></i>查看</el-link>
                        </span>
                        <span class="fx fx-c_center">PPT:
                            <span v-if="lesson.ppts.length==0" class="text_info tip"> 未设置</span>
                            <el-link v-else type="primary" @click="setShowResources(lesson.ppts)" :underline="false" class="font12"><i class="iconfont icon-ppt"></i>查看</el-link>
                        </span>
                        <span class="fx fx-c_center">代码:
                            <span v-if="lesson.codes.length==0" class="text_info tip"> 未设置</span>
                            <el-link v-else type="primary" @click="viewCode(lesson.type, lesson.codes[0].id)" :underline="false" class="font12"><i class="iconfont icon-word"></i>查看</el-link>
                        </span>
                    </div>
                    <div style="margin-top: 12px">
                        <tag-group :tags="lesson.tagArray" size="mini" style="justify-content: flex-start"></tag-group>
                    </div>
                </div>

                <div class="fx-g1">{{lesson.introduction}}</div>


            </div>
            <div class="fx fx-m_between fx-c_center font16" style="padding: 15px 0; border-bottom: 1px solid var(--border)">
                <span>课程任务</span>
            </div>

            <div style="padding: 15px 0">
                <div v-for="(task,i) in lesson.tasks" :key="task.id" class="fx fx-c_center info_row task_item" style="margin-bottom: 6px">
                    <div style="width: 200px">任务{{i+1}}：{{task.title}}</div>
                    <div class="fx-g1 task fx fx-m_start fx-c_center task_info" >
                        <span class="fx fx-c_center">讲解视频:
                            <span v-if="task.videos.length==0" class="text_info tip" > 未设置</span>
                            <el-link v-else @click="setShowResources(task.videos)" type="warning" :underline="false" class="font12"><i class="iconfont icon-shipin"></i>查看</el-link>
                        </span>
                        <span class="fx fx-c_center">随堂资料:
                            <span v-if="task.attachments.length==0" class="text_info tip"> 未设置</span>
                            <el-link v-else @click="setShowResources(task.attachments)" type="warning" :underline="false" class="font12"><i class="iconfont icon-word"></i>查看</el-link>
                        </span>
                        <span class="fx fx-c_center">任务卡片:
                            <span v-if="task.tutorials.length==0" class="text_info tip"> 未设置</span>
                            <el-link v-else @click="setShowResources(task.tutorials)" type="warning" :underline="false" class="font12"><i class="iconfont icon-ppt"></i>查看</el-link>
                        </span>
                        <span class="fx fx-c_center">相关代码:
                            <span v-if="task.codes.length==0" class="text_info tip"> 未设置</span>
                            <el-link v-else type="warning" @click="viewCode(lesson.type, task.codes[0].id)"
                                     :underline="false" class="font12"><i class="iconfont icon-word"></i>查看</el-link>
                        </span>
                    </div>
                </div>
            </div>


        </div>
        <ResourceDrawer :showBox="showResources" @play="play"
                        @close="showResources=false" label="资源列表" :resources="currentResources"></ResourceDrawer>
        <VideoDrawer v-if="showVideo" @close="showVideo=false" :url="currentVideo"></VideoDrawer>


    </div>
</template>

<style scoped>
    .tip {
        padding:0 6px 0 12px;
    }
    .item_block {
        background: white;
        padding: 18px 50px;
        border-radius: 6px;
        margin-bottom: 10px;
    }
    .info_row>*:not(:first-child) {
        margin-left: 50px;
    }

    .coverimg {
        width: 160px;
    }
    .lesson_name {
        font-size: 16px;
        font-weight: bold;
        color: var(--dark);
    }
    .lesson_resource i.iconfont, .task_info i.iconfont {
        vertical-align: text-bottom;
    }
    .task_item {
        height: 50px;
        border-bottom: 1px solid var(--border);
    }
</style>
<style>

</style>

<script>
    import ResourceDrawer from '@/components/ResourceDrawer';
    import VideoDrawer from '@/components/VideoDrawer';
    export default {
        components: {
            ResourceDrawer,
            VideoDrawer,
        },
        props: [
            "attr" // {lessonSystem, isCenter: }
        ],
        data() {
            return {
                loading: true,
                showResources: false,
                currentResources: [],

                showVideo: false,
                currentVideo: null,

                isCenter: null, //是否是总部的体系


                lessonSystem: this.attr.lessonSystem,


                lessons: []
            }

        },

        watch: {
        },

        methods: {
            //加载单节课
            loadLesson(lesson) {
                lesson.videos = lesson.resources.filter(r => r.category == 1);
                lesson.plans = lesson.resources.filter(r => r.category == 2);
                lesson.ppts = lesson.resources.filter(r => r.category == 3);
                lesson.codes = lesson.resources.filter(r => r.category == 4);
                lesson.tasks = [];
                let index = -1;

                this.lessons.forEach((item, i) => {
                    if (item.id == lesson.id) {
                        index = i;
                        lesson.tasks = item.tasks;
                        return;
                    }
                })
                if (index == -1) {
                    this.lessons.push(lesson);
                } else {
                    this.$set(this.lessons, index,  lesson);
                }
            },
            //加载所有课
            loadLessons() {
                let url = null;
                if (this.isCenter) {
                    url = "/lesson/listByCenterSystem/";
                } else {
                    url = "/lesson/listBySystem/";
                }
                this.$ajaxGet(url+this.lessonSystem.id, (data) => {
                    let lessons = data.result;
                    lessons.forEach(item => {
                        item.videos = item.resources.filter(r => r.category == 1);
                        item.plans = item.resources.filter(r => r.category == 2);
                        item.ppts = item.resources.filter(r => r.category == 3);
                        item.codes = item.resources.filter(r => r.category == 4);
                        item.tasks = null;
                    })
                    this.lessons = lessons;

                    if (lessons.length == 0) {
                        this.loading = false;
                    } else {
                        this.loadTasks(lessons.map(item => item.id));
                    }

                })
            },

            loadTasks(lessonIds) {
                let url = null;
                if (this.isCenter) {
                    url = "/lessonTask/listByCenterLessons";
                } else {
                    url = "/lessonTask/listByLessons";
                }
                this.$ajaxPost(url, {
                    lessonIds: lessonIds
                }, (data) => {
                    data.result.forEach(item => {
                        item.videos = item.resources ? item.resources.filter(i => i.category == 1) : [],
                            item.codes = item.resources ? item.resources.filter(i => i.category == 3) : [],
                            item.tutorials = item.resources ? item.resources.filter(i => i.category == 4) : [],
                            item.attachments = item.resources ? item.resources.filter(i => i.category == 2) : []
                    })
                    this.lessons.forEach(item => {
                        item.tasks = data.result.filter(task =>  task.lessonId == item.id);
                    })
                    this.loading = false;
                })
            },







            setShowResources(resources) {
                this.currentResources = resources;
                this.showResources = true;
            },

            play(url) {
                this.currentVideo = url;
                this.showVideo = true;
            },
            viewCode(lessonType, id) {
                this.$goEditCode(lessonType, `mode=caseview&id=${id}`);
            }
        },

        created() {
            this.isCenter = this.attr ? this.attr.isCenter : null;
            this.loadLessons();
        }

    }
</script>
